import VIEWPORTS from '../plugins/viewports'
import PARTSLOADER from '../plugins/partsloader'
import GET_ARTICLES from '../plugins/getArticles'
// import FULLCALENDAR from '../plugins/fullcalendar'

// IE11でSVGの外部参照を有効にする
import 'svgxuse'
import GET_CATEGORIES from '../plugins/getCategories'


const l = location

export default function INIT() {
  /*****
   * Promise
   */
  window.load = {
    'header': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'contentFooter': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'footer': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'mapScript': new $.Deferred, // googlemapAPIのURLパラメータでresolveします
  }

  VIEWPORTS() // Viewportの置き換え
  
  //header.html, footer.html読み込み
  PARTSLOADER([
    {
      name: 'footer',
      loadhtml: '/asset/html/footer.html?ts=20201224',
      target: 'footer #footerNav',
      method:'replaceWith',
      callback(r,_){
        GET_ARTICLES('.footer__nav__list[data-plugin="getArticles"]',{
          makeItem(item,opt){
            return $(`<a href="${item.href}" class="footer__nav__item">${item.title}</a>`)[0]
          }
        });
        GET_CATEGORIES('.footer__nav__list[data-plugin="getCategories"]',{
          itemClass: 'footer__nav__item'
        })
      }
    },
    {
      name: 'contentFooter',
      loadhtml: '/asset/html/contentFooter.html',
      target: 'footer,#footer.ui-footer',
      method:'before',
      callback(r,_){
        $('.homeContentslist').insertBefore('#footer');
      }
    },
    {
      name: 'header',
      loadhtml: '/asset/html/header.html?ts=20201224',
      target: 'header',
      method:'replaceWith',
      callback(r,_){
        $('header .header__gmenu li').currentMenu({mode:1,default:999});
        $('header .header__gmenu__subnav').currentMenu({mode:0,default:999});
        $('header .header__gmenu li').each( function( i, li ){
          const is_current = $('a.current', li ).length > 0
          const has_child = $('.header__gmenu__subnav', li).length > 0
          const $currentSubnav = $('header .header__gmenu a.current + .header__gmenu__subnav')
          $(li).hover(() => {
            if( !is_current && has_child ) $currentSubnav.addClass('hide')
          },
          () => $currentSubnav.removeClass('hide') )
        })
        GET_ARTICLES('.header__gmenu').done(() => {
          const url = l.search ? l.pathname+l.search : l.pathname+'?mode=detail&article=1'
          $('header .header__gmenu__subnav [data-plugin="getArticles"]').currentMenu({mode:0,default:999,url});
        })
      }
    }
  ])

  // DOM Ready
  $(() => {
    // <body>にクラス付与
    $.bodyClass();
    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();
    // カレントメニュー
    $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    // ページングテキスト
    $.pagingText({
      prev:'PREV',
      next:'NEXT',
      list:'LIST'
    })
    // ページトップリンクをスクロール量で表示するサンプル
    $.scrollspy({
      trigger:200,
      onBefore(/* pos */) {
        $('.p-gotop__wrap').addClass('hidden');
      },
      onAfter() {
        $('.p-gotop__wrap').removeClass('hidden');
      }
    })
  })

  // $.getFreeBlock({id:2}).then(function(res) {console.log(res)})
  // window.load['contentFooter'].done(() => {
  //   // fullcalendar挿入
  //   FULLCALENDAR(document.querySelectorAll('[data-plugin="calendar"]'),{
  //     googleCalendarApiKey: 'AIzaSyAp7Q8UGPJkuCJnRnq4M9PZgilB1XTkVQM',
  //     contentHeight: 500,
  //     eventSources: [
  //       {
  //         googleCalendarId: 'japanese__ja@holiday.calendar.google.com',
  //         className: 'holiday'
  //       }
  //     ]
  //   })
  // })

}